<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import ContactMetricsDashboard from './ContactMetricsDashboard.vue';
import ContactPurchaseJourney from './ContactPurchaseJourney.vue';
import ContactEventTimeline from './ContactEventTimeline.vue';
import ContactSystemAttributes from './ContactSystemAttributes.vue';

defineProps({
  contactId: { type: Number, required: true },
});

const { t } = useI18n();

const activeTab = ref('dashboard');

const TABS = [
  {
    value: 'dashboard',
    label: () => t('CONTACT_METRICS.METRICS_TABS.DASHBOARD'),
    icon: 'i-lucide-layout-dashboard',
  },
  {
    value: 'journey',
    label: () => t('CONTACT_METRICS.METRICS_TABS.JOURNEY'),
    icon: 'i-lucide-route',
  },
  {
    value: 'events',
    label: () => t('CONTACT_METRICS.METRICS_TABS.EVENTS'),
    icon: 'i-lucide-list',
  },
  {
    value: 'attributes',
    label: () => t('CONTACT_METRICS.METRICS_TABS.ATTRIBUTES'),
    icon: 'i-lucide-sliders-horizontal',
  },
];
</script>

<template>
  <div class="flex flex-col w-full min-h-full">
    <!-- Tab bar — sticky inside scroll container -->
    <div
      class="sticky top-0 z-10 bg-n-solid-1 border-b border-n-weak px-4 sm:px-6 overflow-x-auto"
    >
      <div class="flex items-center gap-1 min-w-max">
        <button
          v-for="tab in TABS"
          :key="tab.value"
          class="inline-flex items-center gap-1.5 px-3 py-3 text-sm font-medium border-b-2 transition-colors"
          :class="
            activeTab === tab.value
              ? 'border-n-teal-9 text-n-teal-11'
              : 'border-transparent text-n-slate-10 hover:text-n-slate-11 hover:border-n-slate-6'
          "
          @click="activeTab = tab.value"
        >
          <span class="size-3.5" :class="tab.icon" />
          {{ tab.label() }}
        </button>
      </div>
    </div>

    <!-- Tab content -->
    <div class="flex-1">
      <ContactMetricsDashboard
        v-if="activeTab === 'dashboard'"
        :contact-id="contactId"
      />
      <ContactPurchaseJourney
        v-else-if="activeTab === 'journey'"
        :contact-id="contactId"
      />
      <ContactEventTimeline
        v-else-if="activeTab === 'events'"
        :contact-id="contactId"
      />
      <ContactSystemAttributes
        v-else-if="activeTab === 'attributes'"
        :contact-id="contactId"
      />
    </div>
  </div>
</template>
